export default __webpack_public_path__ + "static/media/undraw_game_day_ucx9.2b02b3fd.png";